import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=1fab0b6b&scoped=true&"
import script from "./ApplicantDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab0b6b",
  null
  
)

export default component.exports